module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/eyeCream_d1eb4f.png";